<template>
	<div class="adsearchs">
		<div class="search-header">
			<div class="search-toggle" @click="toggleExpand">
				<i :class="isExpanded ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"></i>
				<span>{{ isExpanded ? '收起高级搜索' : '展开高级搜索' }}</span>
			</div>
		</div>
		<el-form v-model="searchParams">
			<!-- <div class="adsearchkey">
				<div class="inputsearch">
					<input v-model.trim="searchParams.queryInfo" clearable @clear="handleSearch" class="keyinput" placeholder="输入标准编号、名称或关键词..." type="text" />
				</div>
				<el-button icon="el-icon-search" round type="primary" @click="handleSearch"> 检索</el-button>
				<div class="searchbtn pointer" style="display: none" @click="handleSearch"><img alt="" src="@/assets/images/searchbanner/search.png" style="width: 21px; margin-right: 10px" /> 检索</div>
			</div> -->
			<transition name="search-expand">
				<div v-show="isExpanded" class="adsearchcon">
				<div class="flexStart">
					<el-row :gutter="30">
						<el-col :span="6">
							<div class="form-group">
								<label class="form-label">标准编号</label>
								<el-input v-model.trim="searchParams.standardCode" class="form-input" placeholder="请输入标准编号" type="text" clearable />
							</div>
						</el-col>
						<el-col :span="6">
							<div class="form-group">
								<label class="form-label">标准名称</label>
								<el-input v-model.trim="searchParams.queryInfo" class="form-input" placeholder="请输入标准名称" type="text" clearable/>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="form-group">
								<label class="form-label">发布单位</label>
								<el-input v-model.trim="searchParams.issueAgency" class="form-input" type="text" placeholder="请输入发布单位" clearable/>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="form-group">
								<label class="form-label">归口单位</label>
								<el-input v-model.trim="searchParams.underAgency" class="form-input" type="text" placeholder="请输入归口单位" clearable/>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="form-group" style="margin-top: 18px;">
								<label class="form-label">发布日期</label>
								<el-date-picker v-model="releaseDate" end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" style="width: 100%" type="daterange" value-format="yyyy-MM-dd">
								</el-date-picker>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="form-group" style="margin-top: 18px;">
								<label class="form-label">实施日期</label>
								<el-date-picker v-model="executeDate" end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" style="width: 100%" type="daterange" value-format="yyyy-MM-dd">
								</el-date-picker>
							</div>
						</el-col>
					</el-row>
				</div>
				<!-- <div class="topicgroup">
					<div class="title">生命周期</div>
					<el-checkbox-group v-model="lifes" class="topcheck">
						<el-checkbox v-for="item in lifeLabelList" :key="item.labelId" :label="item.labelId">{{ item.labelName }}</el-checkbox>
					</el-checkbox-group>
					<div class="title">专业领域</div>
					<el-checkbox-group v-model="majors" class="topcheck">
						<el-checkbox v-for="item in majorLabelList" :key="item.labelId" :label="item.labelId">{{ item.labelName }}</el-checkbox>
					</el-checkbox-group>
					<div class="title">种类</div>
					<el-checkbox-group v-model="searchParams.categoryId" class="topcheck">
						<el-checkbox v-for="item in categoryLabelList" :key="item.categoryId" :label="item.categoryId">{{ item.categoryName }}</el-checkbox>
					</el-checkbox-group>
				</div> -->
				<div style="text-align: center; margin-top: 20px">
					<el-button icon="el-icon-search" round type="primary" @click="handleSearch"> 检索</el-button>
					<el-button icon="el-icon-refresh-right" round @click="handleReset">重置</el-button>
				</div>
			</div>
		</transition>
		</el-form>
	</div>
</template>


<script>
import { getLifeStandardLabel, getMajorStandardLabel, getStandardCategory } from '@/api/standards/search';
import moment from 'moment';

export default {
	inject: ['updateAdgrandNormData'], // 注入祖父组件提供的方法
	data() {
		return {
			isExpanded: false, // 展开/收起状态
			checkAll: false,

			releaseDate: null,
			executeDate: null,

			lifes: [],
			majors: [],

			searchParams: {
				categoryId: [],
				queryInfo: '',
				issueAgency: '',
				underAgency: '',
				issueBegin: '',
				issueEnd: '',
				effectiveBegin: '',
				effectiveEnd: '',
                standardCode: '',
			},

			lifeLabelList: [],
			majorLabelList: [],
			categoryLabelList: []
		};
	},
	components: {},
	created() {
		this.getLifeStandardLabel();
		this.getMajorStandardLabel();
		this.getStandardCategory();
	},
	methods: {
        resetSearchParams(){
            //  console.log('清空-特征全国标准库-banner-参数');// this.$refs['searchForm'].resetFields();
             this.searchParams = {
                categoryId: [], 
                queryInfo: '',
                issueAgency: '',
                underAgency: '',
                issueBegin: '',
                issueEnd: '',
                effectiveBegin: '',
                effectiveEnd: '',
                standardCode: '',
            };
            this.lifes = [];
            this.majors = [];
            this.releaseDate = null;
            this.executeDate = null;
            // this.updateAdgrandNormData(this.searchParams);
        },
		//获取标签(生命周期)
		async getLifeStandardLabel() {
			let res = await getLifeStandardLabel();
			if (res.code == 200) {
				this.lifeLabelList = res.data;
			}
		},

		//获取标签(专业领域)
		async getMajorStandardLabel() {
			let res = await getMajorStandardLabel();
			if (res.code == 200) {
				this.majorLabelList = res.data;
			}
		},

		//获取种类(特种设备)
		async getStandardCategory() {
			let res = await getStandardCategory();
			if (res.code == 200) {
				this.categoryLabelList = res.data;
			}
		},

		// 切换展开/收起状态
		toggleExpand() {
			this.isExpanded = !this.isExpanded;
		},

		handleSearch() {
			if (this.releaseDate == null) {
				this.searchParams.issueBegin = '';
				this.searchParams.issueEnd = '';
			} else {
				if (this.releaseDate[0]) {
					this.searchParams.issueBegin = moment(this.releaseDate[0]).format('YYYY-MM-DD');
				}
				if (this.releaseDate[1]) {
					this.searchParams.issueEnd = moment(this.releaseDate[1]).format('YYYY-MM-DD');
				}
			}
			if (this.executeDate == null) {
				this.searchParams.effectiveBegin = '';
				this.searchParams.effectiveEnd = '';
			} else {
				if (this.executeDate[0]) {
					this.searchParams.effectiveBegin = moment(this.executeDate[0]).format('YYYY-MM-DD');
				}
				if (this.executeDate[1]) {
					this.searchParams.effectiveEnd = moment(this.executeDate[1]).format('YYYY-MM-DD');
				}
			}
			this.searchParams.labelId = this.lifes.concat(this.majors);

			let params = { ...this.searchParams };

			this.updateAdgrandNormData(params);
			return;

			// 将多个参数封装为对象
			// const params = {
			// 	// queryInfo: this.queryInfo,
			// 	issueAgency: this.adsearchform.issueAgency,
			// 	releaseDate: this.adsearchform.releaseDate,
			// 	underAgency: this.adsearchform.underAgency,
			// 	executeDate: this.adsearchform.executeDate
			// };
		},

        handleReset(){
             this.searchParams = {
                categoryId: [], 
                queryInfo: '',
                issueAgency: '',
                underAgency: '',
                issueBegin: '',
                issueEnd: '',
                effectiveBegin: '',
                effectiveEnd: '',
                standardCode: '',
            };
            this.lifes = [];
            this.majors = [];
            this.releaseDate = null;
            this.executeDate = null;
            this.updateAdgrandNormData(this.searchParams);
        }
	}
};
</script>

<style lang="less" scoped>
@border: 1px solid #cee2f9;
@boxshadow: 0px 0px 5px 0px rgba(20, 116, 226, 0.5);
.adsearchs {
	border-radius: 7px 7px 7px 7px;
	background-color: #ffffff;
	
	// 展开/收起按钮样式
	.search-header {
		padding: 15px 20px;
		border-bottom: 1px solid #f0f0f0;
        box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
		
		.search-toggle {
			display: inline-flex;
			align-items: center;
			cursor: pointer;
			color: #1474e2;
			font-size: 14px;
			font-weight: 500;
			transition: all 0.3s ease;
			
			&:hover {
				color: #0f5bb8;
			}
			
			i {
				margin-right: 8px;
				font-size: 16px;
				transition: transform 0.3s ease;
			}
		}
	}
	
	// 展开收起动画
	.search-expand-enter-active,
	.search-expand-leave-active {
		transition: all 0.3s ease;
	}
	
	.search-expand-enter,
	.search-expand-leave-to {
		opacity: 0;
		transform: translateY(-10px);
		max-height: 0;
	}
	
	.search-expand-enter-to,
	.search-expand-leave {
		opacity: 1;
		transform: translateY(0);
		max-height: 1000px;
	}
	
	.adsearchcon {
		overflow: hidden;
	}
	
	.adsearchkey {
		// width: 80%;
		border-radius: 7px 7px 7px 7px;
		background-color: #ffffff;
		display: flex;
		justify-content: start;
		align-items: center;
		box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
		border-radius: 0px 7px 7px 7px;
		.inputsearch {
			width: 90%;
			height: 50px;
			.keyinput {
				border: 0;
				height: 47px;
				line-height: 47px;
				width: 100%;
			}
		}
	}
	.adsearchcon {
		padding: 20px;
		.form-group {
            
			//width: 268px;
			//margin: 10px 48px 0 20px;
		}
		/* 标题样式（label 本身是行内元素，设置为块级元素会自动换行） */
		.form-label {
			display: block; /* 关键：让标题成为块级元素，独占一行 */
			margin-bottom: 10px; /* 标题与输入框之间的间距 */
			font-weight: 400; /* 标题加粗 */
			color: #333;
		}
		/* 输入框样式（input 默认是行内块，设置 width: 100% 占满一行） */
		.form-input {
			width: 100%; /* 输入框占满容器宽度 */
			// padding: 8px 12px;
			height: 38px;
			// border: @border;
			// box-shadow: @boxshadow;
			border-radius: 5px;
			box-sizing: border-box; /* 确保 padding 不影响总宽度 */
		}
		/deep/ .el-input__inner {
			border: @border;
			// box-shadow: @boxshadow;
			border-radius: 5px;
		}
		.topicgroup {
			padding-bottom: 20px;
			.title {
				margin-top: 18px;
				margin-bottom: 4px;
			}
			/deep/ .el-checkbox__inner {
				border: @border;
				// box-shadow: @boxshadow;
			}
		}
	}
}

// 响应式样式
@media screen and (max-width: 768px) {
	.adsearchs {
		.search-header {
			padding: 12px 15px;
			
			.search-toggle {
				font-size: 13px;
				
				i {
					font-size: 14px;
				}
			}
		}
		
		.adsearchcon {
			padding: 15px;
		}
	}
}

@media screen and (max-width: 480px) {
	.adsearchs {
		.search-header {
			padding: 10px 12px;
			
			.search-toggle {
				font-size: 12px;
				
				i {
					font-size: 12px;
					margin-right: 6px;
				}
			}
		}
		
		.adsearchcon {
			padding: 12px;
		}
	}
}
</style>
